import React, { useState } from "react";
import { toast } from "react-toastify";
import CustomButton from "./CustomButton";
import axiosStrapiInstance from "../../axiosStrapi";
import CurriculumOfLovePDF from "../../assets/CurriculumOfLove.pdf";

const FlipBookModal = ({ setFlipBookOpen, enquirySource = "Admission" }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [branches, setBranches] = useState([]);
  const initialValues = {
    name: "",
    email: "",
    phone: "",
  };
  const [formData, setFormData] = useState(initialValues);
  const [loading, setLoading] = useState(false);

  const handleClose = (e) => {
    if (e.target.id === "overlay") {
      setIsOpen(false);
      setFlipBookOpen(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = CurriculumOfLovePDF;
    link.download = "CurriculumOfLove.pdf"; // Name of the file when downloaded
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toast.success("Broucher Downloaded");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    handleDownload();

    try {
      //
      if (!formData.name || !formData.email || !formData.phone) {
        // toast.error("Fill All the Details");
        return;
      }
      if (formData?.phone?.length !== 10) {
        toast.error("Phone No should be of 10 digits");
        return;
      }

      setLoading(true);
      formData.EnquirySource = enquirySource ?? "ContactUs";
      const payload = { data: formData };
      const response = await axiosStrapiInstance.post(
        "/api/enquiries",
        payload
      );

      setFormData(initialValues);
      toast.success("form Submitted Successfully");
      setFlipBookOpen(false);
      setIsOpen(false);
    } catch (error) {
      console.log("error while submiting form", error);
      // toast.error(error?.response?.data?.error?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {isOpen && (
        <div
          id="overlay"
          className="fixed inset-0 flex items-center justify-center bg-opacity-50 z-[1000]"
          style={{ background: "rgba(0, 0, 0, 0.2)" }}
          onClick={handleClose}
        >
          <div className="w-[88vw] lg:w-[500px] z-[1001] h-[50vh]">
            <div className="w-[100%] z-20 font-Lato bg-white rounded-lg  p-5 py-8 sm:py-3 sm:pb-5 shadow-md">
              <h2 className=" font-Lato text-[32px] leading-10 text-[#121212] sm:mt-5 mt-0 font-bold mb-3 sm:mb-6">
                Enquiry Form
              </h2>
              <form onSubmit={handleSubmit} className="space-y-[10px]">
                <div>
                  <label className="block text-[#D31C4F] mb-1">Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg p-2"
                    placeholder="Enter Name"
                  />
                </div>

                <div>
                  <label className="block text-[#D31C4F] mb-1">Email ID</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg p-2"
                    placeholder="Enter Email Address"
                  />
                </div>

                <div>
                  <label className="block text-[#D31C4F] mb-1">Phone No.</label>
                  <input
                    type="number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg p-2 mb-2"
                    placeholder="Enter No."
                  />
                </div>
                <div className="flex gap-9">
                  <CustomButton
                    text={"Download"}
                    paddingX="22px"
                    paddingY="12px"
                    disabled={loading}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FlipBookModal;
